module.exports = __webpack_public_path__ + "static/media/icon-shopping.ec9e1915.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RewardIcon/icon-shopping.svg
// module id = 1436
// module chunks = 1